import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { LoaderService } from '../../../app-core/services/loader.service';
import { AppCommonModule } from '../app-common.module';
import { Observable, Subscription } from 'rxjs';

@Component({
	standalone: true,
	selector: 'app-loader-indicator',
	templateUrl: './loader-indicator.component.html',
	styleUrls: ['./loader-indicator.component.scss'],
	imports: [AppCommonModule],
})
export class LoaderIndicatorComponent implements OnInit, OnDestroy {
	@Input() displayLoadingText: string | null = null;
	isLoading!: Observable<boolean>;
	private sub!: Subscription;

	constructor(private loaderService: LoaderService) {
		this.isLoading = this.loaderService.isLoading$;
	}

	ngOnInit(): void {
		this.sub = this.isLoading.subscribe((loading: any) => {
			if (loading) {
				document.body.style.overflow = 'hidden';
			} else {
				document.body.style.overflow = '';
			}
		});
	}

	ngOnDestroy(): void {
		document.body.style.overflow = '';
		this.sub?.unsubscribe();
	}
}
